import React, { useState } from 'react';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ClientRiskToleranceValue from 'Components/RiskTolerance/ClientRiskToleranceValue';
import styles from './riskToleranceManualLayoutStyles';

const useStyles = makeStyles(styles);

export default function RiskToleranceManualLayout() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const classes = useStyles();

  const [riskToleranceOptions] = useState(resource.meta().field('clients').attr('arrayDef').template.find(t => t.name === 'riskTolerance'));

  return (
    <div>
      <SurveyStepHeader title={resource.attr('primaryText')} subtitle={resource.attr('secondaryText')} />

      <Typography className={classes.tertiaryText} color="primaryGray">{resource.attr('tertiaryText')}</Typography>

      <div className={classes.riskToleranceValues}>
        {resource.attr('clients')?.resources().list().map((client) => (<ClientRiskToleranceValue
          key={client.id()}
          className={classes.client}
          client={client}
          metaOptions={riskToleranceOptions}
        />))}
      </div>

      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </div>
  );
}

RiskToleranceManualLayout.propTypes = {
};

RiskToleranceManualLayout.defaultProps = {
};
